/* eslint-disable */
import { Ble as _ble } from './ble.js'
import { BleMessageSubscriber } from './bleMessenger.js'

BleMessageSubscriber.initialize(_ble, '*')
export var Ble = BleMessageSubscriber
